import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 108px;
`;

export const Header = styled.header`
  display: flex;
  > :last-child {
    margin-left: auto;
  }
`;

export const Wrap = styled.div`
  display: flex;
  gap: 16px;
  > :nth-child(2) {
    margin-right: 16px;
  }
`;
